import { FunctionComponent, useContext } from "react";
import { Redirect } from "react-router-dom";
import { useCompanyLicensesQuery } from "../../graphql/Queries/Licenses/GetCompanyLicenses";
import AnalyzeSelection from "./AnalyzeSelection";
import { UserContext } from "../../components/User/UserProvider";

export const ConfigureAnalyze: FunctionComponent = () => {
    const { enabledFeatures } = useCompanyLicensesQuery();
    const { name } = useContext(UserContext);

    if (!enabledFeatures.analyzeAccess && !enabledFeatures.analyzeSAASAccess) {
        return <Redirect to="/" />;
    }

    return (
        <>
            <AnalyzeSelection user_name={name} />
        </>
    );
};
